var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavComunicados = function SvgNavComunicados(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_comunicados_svg__Capa_2",
    viewBox: "0 0 33.73 31.72"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_comunicados_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.91.75H5.82A5.07 5.07 0 0 0 .75 5.82v14.79c0 2.8 2.27 5.07 5.07 5.07h2.44v3.79c0 1.22 1.38 1.92 2.36 1.21 2.08-1.51 5.04-3.67 6.83-5h10.46c2.8 0 5.07-2.27 5.07-5.07V5.82c0-2.8-2.27-5.07-5.07-5.07Z",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "1.5px",
    stroke: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.18,
    height: 3.43,
    x: 7.77,
    y: 7.22,
    rx: 1.37,
    ry: 1.37,
    stroke: "#2ad2c5",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "1.5px"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.18,
    height: 3.43,
    x: 7.77,
    y: 15.66,
    rx: 1.37,
    ry: 1.37,
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "1.5px",
    stroke: "#b3b3b3"
  }))));
};
export default SvgNavComunicados;